import { HTTPVerbs } from '@nextgen-web-framework/core';
import type { RequestOptions } from '@nextgen-web-framework/core';
import { CartId, EntryId, SubCartId, ListId, API_Version_CART } from './endPointConstants';

export const getCartReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}`,
  method: HTTPVerbs.GET,
  retries: 0,
};

export const getMiniCartReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/miniCart`,
  method: HTTPVerbs.GET,
  retries: 0,
};

export const updateCartEntriesReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/subCarts/${SubCartId}/entries`,
  method: HTTPVerbs.PATCH,
  retries: 0,
};

export const getCartsReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts`,
  method: HTTPVerbs.GET,
  retries: 0,
};

export const createCartReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts`,
  method: HTTPVerbs.POST,
  retries: 0,
};

export const addToCartReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/entries`,
  method: HTTPVerbs.POST,
  retries: 0,
};

export const deleteCartReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}`,
  method: HTTPVerbs.DELETE,
  retries: 0,
};

export const clearCartEntriesReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/entries`,
  method: HTTPVerbs.DELETE,
  retries: 0,
};

export const getProfilesReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/accounts`,
  method: HTTPVerbs.GET,
};

export const redeemReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/redeem`,
  method: HTTPVerbs.POST,
};

export const addToCartGCOObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/subCarts`,
  method: HTTPVerbs.PUT,
};

export const updateGCOFlagReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/subCarts/${SubCartId}`,
  method: HTTPVerbs.PATCH,
};

export const updateCartReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/subCarts/${SubCartId}`,
  method: HTTPVerbs.PATCH,
};

export const createSubCartReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/subCarts`,
  method: HTTPVerbs.POST,
};

export const clearSubCartEntriesReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/subCarts/${SubCartId}/entries`,
  method: HTTPVerbs.DELETE,
};

export const deleteSubCartReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/subCarts/${SubCartId}`,
  method: HTTPVerbs.DELETE,
};

export const getReassignCartReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/subCarts/${SubCartId}`,
  method: HTTPVerbs.PATCH,
};

export const changeSubCartReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/subCarts/${SubCartId}/entries/${EntryId}`,
  method: HTTPVerbs.PUT,
};

export const getSubCartReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/subCarts/${SubCartId}`,
  method: HTTPVerbs.GET,
};

export const removeQtySubCartReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/subCarts/${SubCartId}/entries/${EntryId}`,
  method: HTTPVerbs.DELETE,
};

export const addToSubCartReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/subCarts/${SubCartId}/entries`,
  method: HTTPVerbs.POST,
};

export const getCartByIdReqObj: RequestOptions = {
  url: `/cart/${CartId}`,
};

export const getListByIdReqObj: RequestOptions = {
  url: `/list/${ListId}`,
};

export const applyCouponReqObj: RequestOptions = {
  url: `/comcartas/${API_Version_CART}/carts/${CartId}/subCarts/${SubCartId}/coupons`,
  method: HTTPVerbs.POST,
};
